// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"N1-z","displaySixCardTiles":"O1-z"};